/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Report_SentInputs */

const en_us2_exercise_sheet_report_sent = /** @type {(inputs: Exercise_Sheet_Report_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thanks! We'll review this exercise.`)
};

const pt_br2_exercise_sheet_report_sent = /** @type {(inputs: Exercise_Sheet_Report_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obrigado! Vamos revisar este exercício.`)
};

const es_419_exercise_sheet_report_sent = /** @type {(inputs: Exercise_Sheet_Report_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Gracias! Vamos a revisar este ejercicio.`)
};

const pt_pt2_exercise_sheet_report_sent = /** @type {(inputs: Exercise_Sheet_Report_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obrigado! Vamos rever este exercício.`)
};

const fr_fr2_exercise_sheet_report_sent = /** @type {(inputs: Exercise_Sheet_Report_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merci ! Nous allons vérifier cet exercice.`)
};

const de_de2_exercise_sheet_report_sent = /** @type {(inputs: Exercise_Sheet_Report_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danke! Wir prüfen diese Übung.`)
};

const it_it2_exercise_sheet_report_sent = /** @type {(inputs: Exercise_Sheet_Report_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grazie! Controlleremo questo esercizio.`)
};

/**
* | output |
* | --- |
* | "Thanks! We'll review this exercise." |
*
* @param {Exercise_Sheet_Report_SentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_report_sent = /** @type {((inputs?: Exercise_Sheet_Report_SentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Report_SentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_report_sent(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_report_sent(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_report_sent(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_report_sent(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_report_sent(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_report_sent(inputs)
	return en_us2_exercise_sheet_report_sent(inputs)
});
export { exercise_sheet_report_sent as "exercise-sheet.report_sent" }